<template>
  <!-- 个人云盘页面 -->
  <div class="register">
    <!-- 搜索 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="modalFormOk">
        <a-row :gutter="24">
          <a-col :xl="7" :lg="7" :md="8" :sm="24">
            <a-form-item label="文件名">
              <a-input placeholder="请输入文件名" v-model="searchFileName" allowClear/>
            </a-form-item>
          </a-col>
          <a-col :xl="7" :lg="7" :md="8" :sm="24">
            <div class="table-operator">
              <a-button  class="rate-btn" @click="modalFormOk" icon="search">查询</a-button>
              <a-button class="rate-btn"  @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮 -->
    <div class="table-operator">
      <a-row type="flex">
        <a-col flex="145px">
          <a-button  @click="handleAddThis" class="rate-btn"  icon="folder-add">新建文件夹</a-button>
        </a-col>
        <a-col flex="100px">
          <a-upload
            name="file"
            :action="this.axios.defaults.baseURL+'/stu/fileStorage/upload'"
            :headers="this.token"
            :data='{"parentId":breadcrumbList[breadcrumbList.length-1].id}'
            :multiple="false"
            :show-upload-list="false"
            :before-upload="beforeUpload"
            @change="handleChange">
            <a-button class="rate-btn" >
              <a-icon type="upload"/>
              上传
            </a-button>
          </a-upload>
        </a-col>
        <a-col flex="auto">
          <a-button  @click="handleRecycle" class="rate-btn"  icon="delete">回收站</a-button>
        </a-col>
      </a-row>

    </div>
    <!-- 导航栏 -->
     <div class="ant-alert ant-alert-info" style="margin-top: 10px" >
       <a-row type="flex">
         <a-col flex="auto">
           <a-breadcrumb>
             <a-breadcrumb-item v-for="(item, index) in breadcrumbList" @click.native="breadcrumbClick(item.id)" :key="index">
               <a style=""> {{ item.name }}</a>
             </a-breadcrumb-item>
           </a-breadcrumb>
         </a-col>
         <a-col flex="200px">容量 {{maxFileStorageSize}} MB / {{sumFileSize}} MB</a-col>
       </a-row>
     </div>
    <!-- table -->
     <a-table
       style="padding:10px;"
       :columns="columns"
       :data-source="dataSource"
       :loading="loading"
       :pagination="false"
     >
       <template slot="fileName" slot-scope="text,record">
         <a v-if="record.fileType === 1" style="color: #1890ff" @click="clickFile(record)"><a-icon type="folder-open" :style="iconFontSize" theme="twoTone"></a-icon> {{ text }}</a>
         <span v-if="record.fileType === 2"><a-icon type="file" :style="iconFontSize" theme="twoTone"></a-icon> {{ text }}</span>
         <span v-if="record.fileType === 3"><a-icon type="file-zip" :style="iconFontSize" theme="twoTone"></a-icon> {{ text }}</span>
         <span v-if="record.fileType === 4"><a-icon type="file-image" :style="iconFontSize" theme="twoTone"></a-icon> {{ text }}</span>
       </template>

       <template slot="action" slot-scope="text, record">
           <a class="tag-read" v-if="record.fileType !== 1" @click='share(record)'>分享</a>
           <a class="tag-read" v-if="record.fileType === 1" @click='handleEdit(record)'>编辑</a>
           <a-divider type="vertical"/>
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down"/></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
       <template slot="fileSize" slot-scope="text, record">
        <span>{{ text }} MB</span>
       </template>
     </a-table>

    <a-modal
      title="编辑"
      :visible="formVisible"
      @ok="formOk"
      :confirm-loading="confirmLoading"
      @cancel="formCancel">
      <a-form :form="form">
        <a-row :gutter="24" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-col >
            <a-form-item label="文件名"  :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input  v-decorator="['fileName', validatorRules.fileName]"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>

    <a-modal
      title="分享"
      :visible="shareVisible"
      @ok="shareOk"
      width="400px"
      ok-text="复制文件链接"
      :footer="null"
      @cancel="shareCancel">
      <a-row>
        <a-col :span="12" :offset="6" style="text-align: center;">
          <a-icon v-if="shareRecore.fileType === 1" type="folder-open" :style="iconFontSizeShare" theme="twoTone"></a-icon>
          <a-icon v-if="shareRecore.fileType === 2" type="file" :style="iconFontSizeShare" theme="twoTone"></a-icon>
          <a-icon v-if="shareRecore.fileType === 3" type="file-zip" :style="iconFontSizeShare" theme="twoTone"></a-icon>
          <a-icon v-if="shareRecore.fileType === 4" type="file-image" :style="iconFontSizeShare" theme="twoTone"></a-icon>
        </a-col>
        <a-col :span="24" class="positionTop" >
          <div class="divfont">详细信息</div>
        </a-col>
        <a-col :span="24" class="positionTop">
          <div style="color: #7A7A7AFF;">文件名： {{shareRecore.fileName}}</div>
          <div style="color: #7A7A7AFF;">大小： {{shareRecore.fileSize}} MB</div>
        </a-col>
        <a-col :span="24" class="positionTop">
          <div class="divfont">文件位置</div>
        </a-col>
        <a-col :span="24" class="positionTop">
          <a-breadcrumb id="breadcrumbid"  separator=">">
            <a-breadcrumb-item style="color: #7A7A7AFF;margin: 0px 0px" v-for="(item, index) in breadcrumbList" :key="index">
              {{ item.name }}
            </a-breadcrumb-item>
          </a-breadcrumb>
        </a-col>
        <a-col :span="24" class="positionTop">
          <div class="divfont">创建时间</div>
        </a-col>
        <a-col :span="24" class="positionTop">
          {{shareRecore.createTime}}
        </a-col>
        <a-col :span="24" class="positionTop">
          <div class="divfont">修改时间</div>
        </a-col>
        <a-col :span="24" class="positionTop">
          {{shareRecore.updateTime}}
        </a-col>
        <a-col :span="24" class="positionTop">
          <div class="divfont">分享链接</div>
        </a-col>
        <a-col id="copyInput" :span="24" class="positionTop">
          <a-input  :disabled="true"  v-model="shareRecore.fileUrl" style="width: 80%" />
          <a-button style="border: none"  @click='copyText(shareRecore.fileUrl)'>
            <a-icon type="copy"></a-icon>
          </a-button>
        </a-col>
      </a-row>
      <a-row type="flex" style="margin-top: 10px">
        <a-col flex="auto"></a-col>
        <a-col flex="170px">
          <a-button  @click="shareCancel" >关闭</a-button>
          <a-button style="margin-left: 10px" type="primary"  @click='copyText(shareRecore.fileUrl)'>复制链接</a-button>
        </a-col>
      </a-row>
    </a-modal>

  <recycleStorage ref="modalRecycle"  @ok="modalFormOk"></recycleStorage>
  </div>
</template>
<script>
import recycleStorage from './recycleStorage'
export default {
  name: 'fileStorage',
  components: {
    recycleStorage
  },
  data() {
    return {
      dataSource: [],
      columns: [
        {
          title: '文件名',
          align: 'left',
          dataIndex: 'fileName',
          scopedSlots: {customRender: 'fileName'}
        },
        {
          title: '修改日期',
          align: 'center',
          dataIndex: 'updateTime'
        },
        {
          title: '文件大小（M）',
          align: 'center',
          dataIndex: 'fileSize',
          scopedSlots: {customRender: 'fileSize'}
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: {customRender: 'action'}
        }
      ],
      iconFontSize: {fontSize: '20px'},
      breadcrumbList: [
        {
          id: 'home',
          name: '全部文件'
        }
      ],
      sumFileSize: '0',
      maxFileStorageSize: '0',
      searchFileName: '',
      maxFileSize: 0,
      token: {'X-Access-Token': localStorage.getItem('token')},
      shareVisible: false,
      shareRecore: {},
      iconFontSizeShare: {fontSize: '80px'},
      formVisible: false,
      formData: {
        fileName: ''
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      validatorRules: {
        fileName: {
          rules: [
            { required: true, message: '请输入文件名!'}
          ]
        }
      },
      form: this.$form.createForm(this),
      confirmLoading: false,
      recordId: '',
      loading: false
    }
  },
  created() {
    this.searchQuery()
  },
  methods: {
    clickFile(record) {
      this.searchQuery(record.id)
      this.breadcrumbList.push({'id': record.id, 'name': record.fileName})
    },
    // 点击导航栏
    breadcrumbClick(id) {
      let isdel = false
      for (let i = 0; i < this.breadcrumbList.length; i++) {
        if (isdel) {
          this.breadcrumbList.splice(i, this.breadcrumbList.length - i)
          break
        }
        if (this.breadcrumbList[i].id === id) {
          isdel = true
        }
      }
      this.lodata(id)
    },
    // 重置
    searchReset() {
      this.searchFileName = ''
      this.modalFormOk()
    },
    // 重载列表
    modalFormOk() {
      let currentNode = this.breadcrumbList[this.breadcrumbList.length - 1]
      this.lodata(currentNode.id)
    },
    lodata(id) {
      if (id === 'home') {
        this.searchQuery()
      } else {
        this.searchQuery(id)
      }
    },
    searchQuery(val) {
      this.loading = true
      this.axios.get('/stu/fileStorage/storageList', { params: { id: val, fileName: this.searchFileName } }).then(res => {
        if (res.code === 200) {
          this.dataSource = res.result
        } else {
          this.dataSource = []
        }
        this.getFileSize()
      }).finally(() => {
        this.loading = false
      })
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < this.maxFileSize
      if (!isLt2M) {
        this.$message.error('文件大小限制' + this.maxFileSize + 'MB!')
      }
      return isLt2M
    },
    // 上传文件
    handleChange(info) {
      const status = info.file.status
      if (status === 'uploading') {
        return
      }
      if (status === 'done') {
        if (info.file.response.success) {
          this.modalFormOk()
          this.$message.success(info.file.name + '上传成功')
        } else {
          this.$message.success(info.file.name + info.file.response.message)
        }
      } else if (status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`)
      }
    },
    handleRecycle() {
      this.$refs.modalRecycle.show()
    },
    getFileSize() {
      this.axios.get('/stu/fileStorage/sumStorageSize').then((res) => {
        if (res.success) {
          this.sumFileSize = res.result.sumFileSize
          this.maxFileStorageSize = res.result.maxFileStorageSize
          this.maxFileSize = res.result.maxFileSize
        }
      })
    },
    // 分享
    share(record) {
      this.shareVisible = true
      this.shareRecore = record
    },

    handleDelete(id) {
      this.axios.delete('/stu/fileStorage/delete', {params: { id: id, delType: '0' }}).then((res) => {
        if (res.success) {
          this.$message.success(res.message)
          this.modalFormOk()
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    shareOk() {
      this.shareVisible = false
      this.shareRecore = {}
    },
    shareCancel() {
      this.shareRecore = {}
      this.shareVisible = false
    },
    // 复制链接地址
    copyText(value) {
      let input = document.createElement('input')
      document.getElementById('copyInput').appendChild(input)
      input.value = value
      input.focus()
      input.select()
      try {
        let result = document.execCommand('copy')
        document.getElementById('copyInput').removeChild(input)
        if (!result) {
          this.$message.error('error')
        } else {
          this.$message.success('复制成功')
        }
      } catch (e) {
        document.getElementById('copyInput').removeChild(input)
      }
    },
    // 创建文件夹
    handleAddThis() {
      this.recordId = ''
      this.formVisible = true
      this.form.resetFields()
    },
    // 修改
    handleEdit(record) {
      this.recordId = record.id
      this.formVisible = true
      this.form.resetFields()
      this.$nextTick(() => {
        this.form.setFieldsValue({fileName: record.fileName})
      })
    },
    formOk() {
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          let formData = Object.assign({}, values)
          let currentNode = this.breadcrumbList[this.breadcrumbList.length - 1]
          if (currentNode.id !== 'home') {
            formData.parentId = currentNode.id
          }
          if (!this.recordId) {
            this.axios.post('/stu/fileStorage/add', formData).then((res) => {
              if (res.success) {
                this.$message.success(res.message)
                this.formVisible = false
                this.modalFormOk()
              } else {
                this.$message.warning(res.message)
              }
            }).finally(() => {
              this.confirmLoading = false
            })
          } else {
            formData.id = this.recordId
            this.axios.put('/stu/fileStorage/edit', formData).then((res) => {
              if (res.success) {
                this.$message.success(res.message)
                this.formVisible = false
                this.modalFormOk()
              } else {
                this.$message.warning(res.message)
              }
            }).finally(() => {
              this.confirmLoading = false
            })
          }
        }
      })
    },
    formCancel() {
      this.formVisible = false
    }
  }
}
</script>
<style scoped>
 #breadcrumbid /deep/ .ant-breadcrumb-separator {
  margin: 0 0px;
}
.positionTop {
  margin-top: 5px
}
.divfont {
  font-size: 15px;
  color:#000000FF
}
 /deep/ .ant-alert {
   padding: 8px 15px 8px 20px;

 }
 .rate-btn {
   background: #2caf7a;
   color: #fff;
 }
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/fileStorage.vue